const auth = {
  auth: {
    signin: {
      title: "登入",
      email: "電子郵件",
      password: "密碼",
      remember: "記住我",
      forgot: "忘記密碼？",
      submit: "登入",
      create: "沒有帳戶？",
      createLink: "建立帳戶",
    },
    signup: {
      title: "建立帳戶",
      email: "電子郵件",
      password: "密碼",
      confirmPassword: "確認密碼",
      terms: "我同意條款和條件",
      submit: "註冊",
      login: "已有帳戶？",
      loginLink: "登入",
    },
    forgot: {
      title: "忘記密碼",
      description: "輸入您的電子郵件，我們將向您發送重置密碼的連結。",
      email: "電子郵件",
      submit: "發送重置連結",
      back: "返回登入",
      success: "重置連結已發送到您的信箱。請檢查您的收件匣。",
    },
    reset: {
      title: "重置密碼",
      description: "為您的帳戶建立新密碼。",
      password: "新密碼",
      confirmPassword: "確認密碼",
      submit: "重置密碼",
      login: "返回登入",
      success: "您的密碼已成功重置。即將跳轉到登入頁面。",
      invalidToken: "重置權杖無效或缺失。請重新申請密碼重置連結。",
    },
    email: "電子郵件",
    password: "密碼",
    confirmPassword: "確認密碼",
    forgotPassword: "忘記密碼？",
    rememberMe: "記住我",
    noAccount: "還沒有帳號？",
    hasAccount: "已有帳號？",
    createAccount: "建立帳號",
    resetPassword: "重置密碼",
    resetPasswordLink: "重置密碼連結",
    backToSignIn: "返回登入",
    termsAndConditions: "我同意服務條款和隱私政策",
    emailSent: "重置密碼連結已發送到您的信箱",
    checkEmail: "請檢查您的信箱",
    passwordChanged: "密碼已成功更改",
    signUpSuccess: "註冊成功，請檢查您的信箱進行驗證",
    invalidCredentials: "電子郵件或密碼錯誤",
    passwordMismatch: "兩次輸入的密碼不一致",
    passwordTooShort: "密碼至少需要 8 個字元",
    invalidEmail: "請輸入有效的電子郵件地址",
    emailRequired: "請輸入電子郵件地址",
    passwordRequired: "請輸入密碼",
    confirmPasswordRequired: "請確認密碼",
    termsRequired: "您必須同意服務條款和隱私政策",
    userNotFound: "找不到該使用者",
    emailInUse: "該電子郵件已被註冊",
    weakPassword: "密碼強度太弱",
    resetInvalidToken: "重置權杖無效或已過期，請重新獲取密碼重置連結",
    unexpectedError: "發生了意外錯誤，請稍後再試",
    signinText: "登入",
    signupText: "註冊",
  },
};

export default auth;
